import { useNavigate } from "react-router-dom";

const TopMenu = ({ menuActive }) => {
  const navigate = useNavigate();

  const linkClass = (path) =>
    `cursor-pointer ${
      menuActive === path
        ? "underline"
        : "hover:underline"
    }`;

  return (
    <div className="z-10 fixed top-0 left-0 right-0 flex justify-end bg-[#4F9C9D] text-white text-[16px] p-[5px_50px] gap-[30px]">
      <div className="flex items-center gap-[30px]">
        <div
          className={linkClass("/contact")}
          onClick={() => navigate("/contact")}
        >
          ติดต่อเรา
        </div>

        <div
          className={linkClass("/ansQandA")}
          onClick={() => navigate("/ansQandA")}
        >
          คำถามที่พบบ่อย
        </div>

        <div
          className={linkClass("/questionnaire")}
          onClick={() => navigate("/questionnaire")}
        >
          แบบประเมินความพึงพอใจ
        </div>
      </div>
    </div>
  );
};

export default TopMenu;